import { render, staticRenderFns } from "./OnboardingWhiteGlovePage.vue?vue&type=template&id=754321fe&scoped=true&"
import script from "./OnboardingWhiteGlovePage.vue?vue&type=script&lang=js&"
export * from "./OnboardingWhiteGlovePage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWhiteGlovePage.vue?vue&type=style&index=0&id=754321fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754321fe",
  null
  
)

export default component.exports